import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Column, Row, Heading, HeadingType } from '@as/cotopaxi';
import { useTranslation } from 'react-i18next';
import { DefaultSettings, ErrorMessage } from '@as-react/common-types';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { UpdatePasswordForm } from '../update-password-form/UpdatePasswordForm';
import { Box } from '@yonderland/andes-react';
export const ChangePassword = ({ onSubmit, buttonState, errorFeedback, title, }) => {
    const { t } = useTranslation([I18N_NAMESPACES.account, I18N_NAMESPACES.buy]);
    const validate = (values) => {
        const errors = {};
        if (!values.oldPassword) {
            errors.oldPassword = t(ErrorMessage.REQUIRED);
        }
        else if (values.oldPassword.length < DefaultSettings.MIN_LENGTH_PASSWORD) {
            errors.oldPassword = t(ErrorMessage.ACCOUNT_MIN_LENGTH);
        }
        if (!values.newPassword) {
            errors.newPassword = t(ErrorMessage.REQUIRED);
        }
        else if (values.newPassword.length < DefaultSettings.MIN_LENGTH_PASSWORD) {
            errors.newPassword = t(ErrorMessage.ACCOUNT_MIN_LENGTH);
        }
        if (!values.repeatPassword) {
            errors.repeatPassword = t(ErrorMessage.REQUIRED);
        }
        else if (values.newPassword !== values.repeatPassword) {
            errors.repeatPassword = t(ErrorMessage.PASSWORD_MATCH);
        }
        return errors;
    };
    return (_jsxs(_Fragment, { children: [title.show && (_jsx(Box, { paddingBlockEnd: "4", marginInline: { base: '-4', md: '0' }, children: _jsx(Heading, { type: HeadingType.SMALL_TITLE, children: title.value || t('account.updatePassword') }) })), _jsx(Box, { marginInline: { base: '-4', md: '0' }, children: _jsx(Row, { parent: true, children: _jsx(Column, { gutter: false, mobile: 12, mobileLarge: 12, tabletSmall: 12, grid: 5, children: _jsx(UpdatePasswordForm, { onSubmit: onSubmit, buttonState: buttonState, validate: validate, errorFeedback: errorFeedback }) }) }) })] }));
};
